const contextmenu = "link image imagetools table";

export default contextmenu;
